// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"7414c933","788":"100ba188"}[chunkId] + ".chunk.js";
};